import React, { PropsWithoutRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    FormControlLabel,
    FormGroup,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';

// assets
import {
    UnorderedListOutlined,
    LogoutOutlined,
    FormatPainterOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import { CustomTheme } from 'themes/Theme';
import { useNavigate } from 'react-router-dom';
import DarkModeToggle from '../../../../../components/settings/DarkMode';
import { useTranslation } from '../../../../../contexts/TranslationContext';
import { useSelector } from 'react-redux';
import { SettingsState, Store } from '../../../../../store/types';

// ==============================|| HEADER PROFILE - SETTING TAB ||============================== //

const SettingTab = ({
    handleLogout,
    handleClose,
}: PropsWithoutRef<{
    handleLogout(): void;
    handleClose(ev: React.MouseEvent): void;
}>) => {
    const { translate } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme<CustomTheme>();

    const { branding } = useSelector<Store, SettingsState>(
        state => state.settings,
    );
    const [selectedIndex, setSelectedIndex] = useState(0);

    const openSettings = (event: React.MouseEvent) => {
        setSelectedIndex(1);
        navigate('/settings');
        handleClose && handleClose(event);
    };

    const openHistory = (event: React.MouseEvent) => {
        setSelectedIndex(4);
        navigate('/history');
        handleClose && handleClose(event);
    };

    const darkModeAllowed =
        branding && typeof branding.darkMode !== 'undefined'
            ? branding.darkMode
            : true;

    return (
        <List
            component="nav"
            sx={{
                p: 0,
                '& .MuiListItemIcon-root': {
                    minWidth: 32,
                    color: theme.palette.grey[500],
                },
            }}>
            {darkModeAllowed && (
                <ListItem>
                    <ListItemIcon>
                        <FormatPainterOutlined />
                    </ListItemIcon>
                    <FormGroup sx={{ mx: 0 }} row>
                        <FormControlLabel
                            labelPlacement="start"
                            sx={{ mx: 0 }}
                            control={<DarkModeToggle />}
                            label={translate(
                                'pages.settings.sections.general.dark_mode',
                            )}
                        />
                    </FormGroup>
                </ListItem>
            )}
            <ListItemButton
                selected={selectedIndex === 1}
                onClick={openSettings}>
                <ListItemIcon>
                    <SettingOutlined />
                </ListItemIcon>
                <ListItemText primary={translate('pages.settings.title')} />
            </ListItemButton>
            <ListItemButton
                selected={selectedIndex === 4}
                onClick={openHistory}>
                <ListItemIcon>
                    <UnorderedListOutlined />
                </ListItemIcon>
                <ListItemText primary={translate('pages.history.title')} />
            </ListItemButton>
            <ListItemButton
                selected={selectedIndex === 2}
                onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutOutlined
                        style={{ color: theme.palette.error.main }}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={translate('pages.logout')}
                    sx={{ color: 'error.main' }}
                />
            </ListItemButton>
        </List>
    );
};

export default SettingTab;
